const aptType = {
    'Monolocali': 1,
    'Bilocali' : 2,
    'Trilocali': 3,
    'Quadrilocali': 4,
    'Plurilocali': 5,
    'Attici': 6,
    'Loft': 7,
    'Ville': 8    
};

export default aptType;